import React, { Component } from "react";
import { withStore } from "store/storeHandler";
import { getDateText } from "lib/dateFormatString";
import TXT from "presentational/common/multinational/TXT";
import PropTypes from "prop-types";

class DateText extends Component {
  static propTypes = {
    /**
     * inputType 이 fullDateText 라면
     * '2024-08-20T03:36:34.596Z'이와 같은 값을 입력해야 하지만,
     * '2024-08-20'같은 입력값도 정상 작동하기에 그냥 사용하고 있다.
     */
    inputType: PropTypes.oneOf(["fullDateText", "inputYM"]).isRequired,
    outputType: PropTypes.oneOf(["outputYMD", "outputYM"]).isRequired,

    year: PropTypes.number,
    month: PropTypes.number,
    day: PropTypes.number,

    fullDateText: PropTypes.string,

    displayWeekday: PropTypes.bool
  };

  static defaultProps = {
    year: null,
    month: null,
    day: null,

    fullDateText: null,

    displayWeekday: false
  };

  isNullInput() {
    const { fullDateText, year, month, day } = this.props;
    return !fullDateText && !year && !month && !day;
  }

  render() {
    const {
      fullDateText,
      year,
      month,
      day,
      outputType,
      displayWeekday,
      viewerLocation
    } = this.props;

    if (this.isNullInput()) {
      return (
        <span>
          <TXT name="wordNullDate" />
        </span>
      );
    }

    return (
      <span>
        {getDateText({
          inputDateISOString: fullDateText,
          inputYearNum: year,
          inputMonthNum: month,
          inputDayNum: day,
          outputType,
          displayWeekday,
          location: viewerLocation
        })}
      </span>
    );
  }
}

export default withStore({
  stateMap: {
    userDevice: ["viewerLocation"]
  }
})(DateText);
